import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environment';

@Injectable({
  providedIn: 'root'
})

export class RestService {
  constructor(private http: HttpClient) { }

  get(path: string, httpParams?: HttpParams | {
    [param: string]: string | string[];
  }): Observable<any> {
    return this.http.get(environment.settings.api.url + path, { params: httpParams, reportProgress: true });
  }

  post(path: string, body?: any, httpParams?: HttpParams | {
    [param: string]: string | string[];
  }, httpHeaders?): Observable<any> {
    return this.http.post(environment.settings.api.url + path, body, { headers: httpHeaders, params: httpParams, reportProgress: true });
  }

  put(path: string, body?: any, httpParams?: HttpParams | {
    [param: string]: string | string[];
  }, httpHeaders?): Observable<any> {
    return this.http.put(environment.settings.api.url + path, body, { headers: httpHeaders, params: httpParams, reportProgress: true });
  }

  delete(path: string, httpParams?: HttpParams | {
    [param: string]: string | string[];
  }): Observable<any> {
    return this.http.delete(environment.settings.api.url + path, { params: httpParams });
  }

}
